export const useTranslations = () => useWindow('_translations')
export const useWindow = (property) => window[property]
